export default "__VITE_ASSET__BagWuH8B__"